import { CostCenterAPI } from "api";
import React, { useEffect, useState } from "react";
import { Button, Card, Col, Form, Row, Table } from "react-bootstrap";
import { useFieldArray, useFormContext } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import {
  closestCorners,
  DndContext,
  MouseSensor,
  TouchSensor,
  useSensor,
  useSensors,
} from "@dnd-kit/core";
import {
  SortableContext,
  useSortable,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import ActionButton from "components/common/ActionButton";

const SortableItem = ({ id, children }) => {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  return (
    <tr ref={setNodeRef} style={style}>
      <td
        {...listeners}
        {...attributes}
        style={{
          cursor: "grab",
          textAlign: "center",
          width: "10px",
          // paddingTop: "15px",
        }}
      >
        ☰
      </td>
      {children}
    </tr>
  );
};

const FiscalYearBasicInformation = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    register,
    setValue,
    clearErrors,
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const {
    fields: fiscalPeriods,
    append: appendFiscalPeriods,
    remove: removeFiscalPeriods,
    move,
  } = useFieldArray({
    control,
    name: "fiscalPeriods",
  });

  const [loading, setLoading] = useState(false);

  const maxCharactersLength = 255;

  // const [costCenter, setCostCenter] = useState([]);

  // useEffect(() => {
  //   const fetchCostCenter = async () => {
  //     setLoading(true);
  //     const response = await CostCenterAPI.get();
  //     setCostCenter(response?.data?.data);
  //     setLoading(false);
  //   };
  //   fetchCostCenter();
  // }, []);

  useEffect(() => {
    let startDate = state?.startDate
      ? new Date(state?.startDate).toISOString().split("T")[0]
      : "";
    let endDate = state?.endDate
      ? new Date(state?.endDate).toISOString().split("T")[0]
      : "";
    setValue("startDate", startDate);
    setValue("endDate", endDate);
  }, [state]);

  // console.log(costCenter);

  const sensors = useSensors(
    useSensor(MouseSensor),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 250,
        tolerance: 5,
      },
    })
  );

  const handleDragEnd = (event) => {
    const { active, over } = event;
    if (active.id !== over.id) {
      const oldIndex = fiscalPeriods.findIndex((item) => item.id === active.id);
      const newIndex = fiscalPeriods.findIndex((item) => item.id === over.id);
      move(oldIndex, newIndex);
    }
  };

  // console.log(state);

  return (
    <>
      {loading ? (
        <div className="d-flex py-3 justify-content-center align-items-center">
          <Button variant="falcon-default" size="sm" className="fs-10">
            Loading...
          </Button>
        </div>
      ) : (
        <Card.Body
          className=""
          style={{
            // height: `calc(100vh - 12.7rem)`,
            overflow: "auto",
            padding: "5px 20px",
          }}
        >
          <Row className="gx-2 pb-2">
            {/* <Col md="6">
              <Form.Group>
                <Form.Select
                  aria-label="costCenter"
                  type="text"
                  title="Cost Center"
                  className="py-2"
                  isInvalid={!!errors?.costCenterId}
                  {...register("costCenterId")}
                >
                  <option value="">Select Cost Center</option>
                  {costCenter?.map((item, index) => (
                    <option value={item.id}>{item.name}</option>
                  ))}
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  {errors?.costCenterId?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> */}

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Code"
                  title="Code"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.code}
                  {...register("code")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.code?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>

            <Col md="2">
              <Form.Check
                type="checkbox"
                id="defaultSwitch"
                label="Is Current"
                className="mt-2"
                defaultChecked={!state}
                isInvalid={!!errors.isCurrent}
                {...register("isCurrent")}
              />
            </Col>
            <Col md="2">
              <Form.Check
                type="checkbox"
                id="defaultSwitch"
                label="Is Closed"
                className="mt-2"
                defaultChecked={!state}
                isInvalid={!!errors.isClosed}
                {...register("isClosed")}
              />
            </Col>

            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="text"
                  placeholder="Year Name"
                  title="Year Name"
                  maxLength={maxCharactersLength}
                  className="py-2 "
                  isInvalid={!!errors.name}
                  {...register("name")}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <Form.Control.Feedback
                    type="invalid"
                    className="d-inline w-75"
                  >
                    {errors.name?.message}
                  </Form.Control.Feedback>
                </div>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="Start Date"
                  title="Start Date"
                  className="py-2 mb-1"
                  isInvalid={!!errors.startDate}
                  // value={moment.utc(state?.postDate).format("YYYY-MM-DD")}
                  // defaultValue={state?.postDate.split("T")[0]}
                  {...register("startDate")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.startDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Control
                  type="date"
                  placeholder="End Date"
                  title="End Date"
                  className="py-2 mb-1"
                  isInvalid={!!errors.endDate}
                  // value={moment.utc(state?.postDate).format("YYYY-MM-DD")}
                  // defaultValue={state?.postDate.split("T")[0]}
                  {...register("endDate")}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.endDate?.message}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row className="gx-2 ">
            <DndContext
              sensors={sensors}
              collisionDetection={closestCorners}
              onDragEnd={handleDragEnd}
            >
              <SortableContext
                items={fiscalPeriods.map((item) => item.id)}
                strategy={verticalListSortingStrategy}
              >
                <Table responsive>
                  <thead className="bg-200">
                    <tr>
                      <th scope="col" className="w-0 fs-10 text-center"></th>
                      <th scope="col" className="w-0 fs-10 text-center">
                        Sr. no.
                      </th>

                      <th scope="col" className="fs-10">
                        Name
                      </th>
                      <th scope="col" className="fs-10">
                        Start Date
                      </th>

                      <th scope="col" className="fs-10">
                        End Date
                      </th>

                      <th scope="col" className="fs-10 text-center">
                        Is Closed
                      </th>

                      <th
                        scope="col"
                        style={{ padding: "9px", width: "10px" }}
                        className=" text-end"
                      >
                        <ActionButton
                          icon="plus"
                          variant="success"
                          title="Add"
                          className="px-1 py-0"
                          onClick={() => appendFiscalPeriods({})}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {fiscalPeriods.map((item, index) => (
                      <SortableItem key={item.id} id={item.id}>
                        <td style={{ padding: "12px" }} className="text-center">
                          {index + 1}
                        </td>

                        <td style={{ padding: "10px" }}>
                          <Form.Control
                            type="text"
                            placeholder="Name"
                            isInvalid={!!errors.fiscalPeriods?.[index]?.name}
                            {...register(`fiscalPeriods[${index}].name`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.fiscalPeriods?.[index]?.name?.message}
                          </Form.Control.Feedback>
                        </td>
                        <td style={{ padding: "10px" }}>
                          <Form.Control
                            type="date"
                            placeholder="Start Date"
                            isInvalid={
                              !!errors.fiscalPeriods?.[index]?.startDate
                            }
                            {...register(`fiscalPeriods[${index}].startDate`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.fiscalPeriods?.[index]?.startDate?.message}
                          </Form.Control.Feedback>
                        </td>
                        <td style={{ padding: "10px" }}>
                          <Form.Control
                            type="date"
                            placeholder="End Date"
                            isInvalid={!!errors.fiscalPeriods?.[index]?.endDate}
                            {...register(`fiscalPeriods[${index}].endDate`)}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors.fiscalPeriods?.[index]?.endDate?.message}
                          </Form.Control.Feedback>
                        </td>
                        <td style={{ padding: "10px" }} className="text-center">
                          <Form.Check
                            type="checkbox"
                            id="defaultSwitch"
                            // label="Is Current"
                            className="mt-2"
                            defaultChecked={!state}
                            isInvalid={
                              !!errors.fiscalPeriods?.[index]?.isClosed
                            }
                            {...register(`fiscalPeriods[${index}].isClosed`)}
                          />

                          {/* <Form.Control
                            type="text"
                            placeholder="Debit"
                            isInvalid={!!errors.fiscalPeriods?.[index]?.debit}
                            {...register(`fiscalPeriods[${index}].debit`)}
                          /> */}
                          <Form.Control.Feedback type="invalid">
                            {errors.fiscalPeriods?.[index]?.debit?.message}
                          </Form.Control.Feedback>
                        </td>

                        <td
                          style={{
                            paddingLeft: "9px",
                            maxWidth: "10px",
                          }}
                          className="text-center"
                        >
                          <ActionButton
                            icon="trash-alt"
                            title="Delete"
                            variant="danger"
                            className="px-1 py-0"
                            onClick={() => removeFiscalPeriods(index)}
                          />
                        </td>
                      </SortableItem>
                    ))}
                  </tbody>
                </Table>
              </SortableContext>
            </DndContext>
          </Row>
        </Card.Body>
      )}
    </>
  );
};

export default React.memo(FiscalYearBasicInformation);
